import React, { useEffect, useState, useContext } from "react";
import { Typography, Box, Backdrop, CircularProgress, TableCell} from "@mui/material";
import Header from "./Header";
import { API } from "../conf";
import { Context } from "../App";
import moment from 'moment';
import {theme} from '../App'
import CollapsibleTable from "./collap-table";

export default function JrnComptes() {
    const { updateConnect } = useContext(Context)
    const table = [
        {header: "N° compte", header_align:'left', row: (row, index)=><TableCell key={index} sx={{minWidth:'150px'}}>{row.num_compte}</TableCell>},
        {header: "Libellé", header_align:'left', row: (row, index)=><TableCell key={index} sx={{minWidth:'150px', width:'100%'}}>{row.libelle}</TableCell>},
        {header: "Solde", header_align:'center', row: (row, index)=><TableCell key={index} align="right" sx={{ minWidth:'120px'}} style={{fontWeight:'bold', color: row.solde>=0? theme.palette.valide.main : theme.palette.carmine.main}}>{(row.solde>0?'+':'')+row.solde.toFixed(2)}€</TableCell>},
    ]

    const [loading, setLoad] = useState(true)
    const [comptes, setComptes] = useState()
    const [petite_caisse, setPC] = useState()

    useEffect(()=>{
        function get_comptes() {
            const eglise = JSON.parse(sessionStorage.getItem('eglise'))
    
            fetch(API.concat(`/comptes/by/${JSON.stringify({eglise: eglise.number})}`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        const sorted = json.filter(cpt=> cpt.type!=='petite-caisse').sort((a, b) => a.type==='liaison' ? -1 : b.type==='liaison' ? 1 : 0)
                        setComptes(sorted)
                        setPC(json.find(cpt=> cpt.type==='petite-caisse'))
                    }
                    setLoad(false)
                }
            })
        }

        get_comptes()
    }, [updateConnect])     
    
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Consultation des Comptes</Typography>
            <Box sx={{paddingX:'20px', marginTop:'30px'}}>
                {comptes && !loading && 
                <CollapsibleTable 
                total={comptes.filter(cpt=>cpt.type!=='liaison').reduce((tt, cpt)=>tt+cpt.solde,0)} 
                table={table} 
                data={comptes} 
                petite_caisse={petite_caisse?.solde??0}
                start_date={moment().add(-30,'day').format('yyyy-MM-DD')} 
                end_date={moment().format('yyyy-MM-DD')}/>}
            </Box>

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>
        </div>
    )
}